import React from "react";
import { Calendar } from "lucide-react";
const fmtDate = (dateStr) => {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

/**
 * DateFilter
 * Specialized date picker for filtering with stylized display labels.
 */
const DateFilter = ({ value, onChange, label, min, max }) => (
  <div className={`relative flex items-center gap-2 px-3 py-2 rounded-md border text-[12px] font-bold transition-all cursor-pointer shrink-0 ${value ? "bg-slate-900 text-white border-slate-900 shadow-md" : "bg-white border-slate-200 text-slate-600 hover:border-slate-400 hover:text-slate-950 shadow-sm"}`}>
    <Calendar size={14} className="shrink-0 pointer-events-none" />
    <span className="pointer-events-none">{value ? fmtDate(value) : label}</span>
    <input
      type="date"
      value={value || ""}
      min={min}
      max={max || new Date().toISOString().split('T')[0]}
      onChange={(e) => onChange(e.target.value)}
      onClick={(e) => e.target.showPicker?.()}
      className="absolute inset-0 opacity-0 cursor-pointer w-full h-full z-10"
    />
  </div>
);

export default DateFilter;




